import axios from 'axios';

// 创建一个 Axios 实例
const api = axios.create({
  timeout: 5000, // 设置超时时间
});

// 请求拦截器
api.interceptors.request.use(
  (config) => {
    // 在发送请求之前做些什么
    // 例如，添加 token 到 headers
    // config.headers['Authorization'] = 'Bearer ' + getToken();
    return config;
  },
  (error) => {
    // 处理请求错误
    return Promise.reject(error);
  }
);

// 响应拦截器
api.interceptors.response.use(
  (response) => {
    // 在接收响应数据之前做些什么
    return response.data;
  },
  (error) => {
    // 处理响应错误
    return Promise.reject(error);
  }
);


export default api;
